<template>
  <router-view />
</template>

<script>
export default {
  name: 'TipsIndex',
}
</script>
